import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";

// auth pages
import Login from "./modules/Auth/pages/containers/login";

export function Routes() {

  return (
    <Switch>
      {!localStorage.getItem("access_token") ? (
        <Switch>
          <Route path="/auth/login" component={Login} />
          <Redirect from="/auth" exact={true} to="/auth/login" />
          <Redirect to="/auth/login" />
        </Switch>
      ) : (
        <Layout>
          <BasePage />
        </Layout>
      )}
      <Route path="/error" component={ErrorsPage} />
    </Switch>
  );
}
